
      if (import.meta.env.VITE_REACT_APP_ENV !== "development") {
        const script = document.createElement("script");
        script.src =
          "https://app.brightback.com/js/current/brightback.js?compiled=true";
        document.body.appendChild(script);
      }
    